export function Tabs({
  activeTab,
  setActiveTab,
  isNewEmployee = false,
  isRejoinPrefill = false,
  onCloseForm,
  isEmployeeView = false,
  employee = {},
  availableTabs = null, // Progression lock: new-employee ESS onboarding only
  allowedByPermissionTabs = null,
}) {
  // ✅ Determine PF applicability safely from multiple sources
  const isPfApplicable =
    employee?.pfApplicable === true ||
    employee?.orgDetails?.pfApplicable === true ||
    employee?.statutoryApplicability?.pfApplicable === true;

  // ✅ Determine ESI applicability safely from multiple sources
  const isEsiApplicable =
    employee?.esiApplicable === true ||
    employee?.orgDetails?.esiApplicable === true ||
    employee?.statutoryApplicability?.esiApplicable === true;

  // ✅ Tabs list (Statutory Details included if PF or ESI is applicable)
  const tabs = [
    { id: "org", label: "Org Details" },
    { id: "personal", label: "Personal" },
    { id: "family", label: "Family" },
    { id: "bank", label: "Bank" },
    { id: "educational", label: "Education" },
    { id: "professional", label: "Profession" },
    ...(isPfApplicable || isEsiApplicable
      ? [{ id: "statutory", label: "Statutory Details" }]
      : []),
    { id: "documents", label: "Documents" },
  ];

  const hideTabsWithoutViewAccess =
    isEmployeeView && Array.isArray(allowedByPermissionTabs);

  const tabsToRender = hideTabsWithoutViewAccess
    ? tabs.filter((t) => allowedByPermissionTabs.includes(t.id))
    : tabs;

  return (
    <div className="relative z-10 flex h-12 border-b border-gray-200 bg-white font-sans subpixel-antialiased dark:border-[#3C3C4C] dark:bg-[#1D1D1D]">
      {tabsToRender.map((tab) => {
        const isOrgFirstLock = isNewEmployee && !isRejoinPrefill && tab.id !== "org";

        const isProgressionLocked =
          isEmployeeView &&
          isNewEmployee &&
          !isRejoinPrefill &&
          Array.isArray(availableTabs) &&
          !availableTabs.includes(tab.id);

        const isDisabled = isOrgFirstLock || isProgressionLocked;

        return (
          <button
            key={tab.id}
            type="button"
            className={`py-3 px-4 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-redhalo-red/40 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-[#1D1D1D] ${
              activeTab === tab.id
                ? "border-b-2 border-redhalo-red bg-white text-redhalo-red dark:border-redhalo-red dark:bg-[#1D1D1D] dark:text-redhalo-red"
                : isDisabled
                ? "cursor-not-allowed bg-white text-redhalo-red/70 dark:bg-[#1D1D1D] dark:text-redhalo-red/70"
                : "bg-white text-redhalo-red hover:bg-redhalo-mint/10 hover:text-redhalo-red dark:bg-[#1D1D1D] dark:text-redhalo-red dark:hover:bg-[#2a2a2a] dark:hover:text-redhalo-red"
            }`}
            onClick={() => !isDisabled && setActiveTab(tab.id)}
            disabled={isDisabled}
            title={
              isOrgFirstLock
                ? "Complete Organization Details first"
                : isProgressionLocked
                ? "Complete previous sections to unlock this tab"
                : ""
            }
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
